import React, { useEffect, useState } from 'react';
import "./ServiceBox.css";
import { useNavigate } from "react-router-dom";
import { ContextMenu } from '../../../components/contextMenu/contextMenu';

const ServiceBox = ({ id, serviceInfo, goToService, selecteService, goToDelete }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    // const navigate = useNavigate();

    function toService() {
        goToService();
        selecteService(serviceInfo)
        // navigate("service/" + serviceInfo.id);
    }

    const handleContextMenu = (e) => {
        e.preventDefault();
        setMenuPosition({ x: e.pageX , y: e.pageY});
        setShowMenu(true);
    };

    useEffect(() => {
                document.addEventListener("click", (e)=>{setShowMenu(false)});
                return () => {
                  document.removeEventListener("click", (e)=>{setShowMenu(false)});
                };
              }, []);

    return (
        <div>
            <div id={id} className='service-box shadow-glow glassmorphism' onClick={toService} onContextMenu={handleContextMenu}>
                <h1>{serviceInfo.service_name}</h1>
                </div>
                {showMenu && (
                        <ContextMenu menuPosition={menuPosition} options={[
                            {
                                onClick: goToDelete,
                                name: "delete"
                            }
                        ]}/>
                    )}
        </div>
    );
};

export default ServiceBox;